import { create } from "zustand";

interface SelectExtractAssetsState {
  selectedExtractAssets: string[];
  setSelectedExtractAssets: (assetIds: string[]) => void;
}

export const useSelectExtractAssetsStore = create<SelectExtractAssetsState>((set) => ({
  selectedExtractAssets: [],
  setSelectedExtractAssets: (assetIds) => set((state) => ({
    selectedExtractAssets: [...assetIds]
  })),
}));